import { render, staticRenderFns } from "./mis-datos-personales.vue?vue&type=template&id=355c6636"
import script from "./mis-datos-personales.vue?vue&type=script&lang=js"
export * from "./mis-datos-personales.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports